export class HealthMonitor {
  private static checks: Map<string, () => Promise<boolean>> = new Map();

  static registerCheck(name: string, check: () => Promise<boolean>): void {
    this.checks.set(name, check);
  }

  static async runHealthChecks(): Promise<Record<string, boolean>> {
    const results: Record<string, boolean> = {};

    await Promise.all(
      Array.from(this.checks.entries()).map(async ([name, check]) => {
        try {
          results[name] = await check();
        } catch {
          console.error(`Health check failed for ${name}`);
          results[name] = false;
        }
      })
    );

    return results;
  }

  static async checkApiHealth(): Promise<boolean> {
    try {
      const response = await fetch("/health");
      return response.ok;
    } catch {
      return false;
    }
  }

  static checkLocalStorage(): boolean {
    try {
      const test = "test";
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch {
      return false;
    }
  }
}

HealthMonitor.registerCheck("api", HealthMonitor.checkApiHealth);
HealthMonitor.registerCheck("localStorage", () =>
  Promise.resolve(HealthMonitor.checkLocalStorage())
);
